__turbopack_context__.v({
  "deleted-account": "index-module-scss-module__h1mOmq__deleted-account",
  "info-box": "index-module-scss-module__h1mOmq__info-box",
});
